import { Component, HostListener, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CustomFieldTypeEnum } from "src/app/enums/customFieldType.enum";
import { CustomField } from "src/app/models/customField.model";
import { Enum } from "src/app/models/enum.model";
import { CustomObjectService } from "src/app/services/customObject.service";
import { ToastService } from "src/app/services/toast.service";

import { trackById } from "src/app/shared/utils/track-by.util";
export interface CustomFieldDialogData {
    names: string[];
    customField: CustomField;
}

@Component({
  standalone: false,
    selector: "app-custom-field-dialog",
    templateUrl: "./custom-field-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./custom-field-dialog.component.scss"],
})
export class CustomFieldDialogModalComponent implements OnInit {
    isFormLoading = false;
    customFieldTypes: Enum[];
    CustomFieldTypeEnum = CustomFieldTypeEnum;
    customField: CustomField;

    constructor(
        public dialogRef: MatDialogRef<CustomFieldDialogModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CustomFieldDialogData,
        private customObjectService: CustomObjectService,
        private toastService: ToastService,
    ) {
        this.customField = data.customField;
    }

    ngOnInit() {
        this.isFormLoading = true;
        this.customObjectService.getCustomFieldTypes().subscribe(
            (result) => {
                this.customFieldTypes = result;
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }


    isDisabled() {
        return (
            !this.customField ||
            !this.customField.name ||
            this.customField.type === undefined ||
            (this.customField.type === CustomFieldTypeEnum.SingleSelect &&
                !this.customField.data)
        );
    }

    ok() {
        if (
            this.data.names
                .map((x) => x.toLowerCase())
                .includes(this.customField.name.toLowerCase())
        ) {
            this.toastService.showWarning(
                "Duplicate Name: Please select another value.",
                true,
            );
            return;
        }
        this.dialogRef.close(this.customField);
    }

    @HostListener("window:resize", ["$event"])
    onWindowResize(event) {
        this.dialogRef.updatePosition({});
    }

    public trackById = trackById;
}
